/**
 * Bundle 84 Task 5 - minimal, privacy-first layout for /survey/*.
 * Marketing chrome (nav + sign in + footer with links) is stripped so
 * a signed survey link does not leak brand-nav CTAs across a sensitive
 * private surface. Logo lockup only in the header. Footer carries
 * Privacy + Contact links in small text.
 * No em/en dashes, no eslint-disable, no photo/image alt copy.
 */
import React, { useEffect } from 'react';
import { Outlet, Link } from 'react-router-dom';

const SurveyMinimalLayout = () => {
  useEffect(() => {
    // Bundle 84 Task 1 - defence in depth. Stop PostHog session
    // replay + capture even if a re-render somehow initialized it
    // after our early gate.
    try {
      if (window.posthog) {
        if (typeof window.posthog.stopSessionRecording === 'function') {
          window.posthog.stopSessionRecording();
        }
        if (typeof window.posthog.opt_out_capturing === 'function') {
          window.posthog.opt_out_capturing();
        }
      }
    } catch (_) { /* silent */ }
    // Meta Pixel: NEVER init on this route. If somehow present, drop
    // the queue so no in-flight fbq('track', ...) call fires.
    try {
      if (window.fbq && Array.isArray(window.fbq.queue)) {
        window.fbq.queue.length = 0;
      }
    } catch (_) { /* silent */ }
  }, []);

  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col" data-testid="survey-minimal-layout">
      <header className="border-b border-neutral-200 bg-white">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="font-display text-xl font-bold text-primary-900" data-testid="survey-logo">
            Dostination
          </div>
          <div className="text-[10px] uppercase tracking-widest text-neutral-500">
            Private feedback
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-neutral-200 py-4 text-center text-[11px] text-neutral-500">
        <Link to="/privacy" className="hover:text-primary-800" target="_blank" rel="noopener noreferrer">Privacy</Link>
        <span className="mx-2">*</span>
        <a href="mailto:hello@dostination.com" className="hover:text-primary-800">Contact</a>
      </footer>
    </div>
  );
};

export default SurveyMinimalLayout;
